module.exports = __webpack_public_path__ + "img/produccion.43e57989.png";